<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { SourceSetQuery } from "@core/schema/SourceSetQuery.js";

	const {
		heading,
		tip,
		sources,
		media,
		align = "left",
		class: customClass,
	}: {
		heading: string;
		tip: string;
		sources: Partial<Record<SourceSetQuery, string>> & { default: string };
		media?: ClassValue;
		align?: "left" | "center" | "right";
		class?: ClassValue;
	} = $props();

	const { default: defaultSrc, ...sourcesets } = $derived(sources);
</script>

<div
	class={[
		"rounded-2xl py-17 px-20 overflow-hidden relative tip-section mx-auto w-full max-w-100 md:max-w-none",
		customClass,
	]}
>
	<Media
		{sourcesets}
		source={{ type: "image/webp", src: defaultSrc }}
		width={0}
		height={0}
		alt=""
		wrapperClass="absolute inset-0"
		class={["absolute inset-0 size-full object-cover", media]}
	/>
	<div
		class={[
			"relative z-10 p-6 flex flex-col gap-3 h-full",
			align === "right" && "items-end text-right",
			align === "center" && "items-center text-center",
		]}
	>
		<Heading level={2} text={heading} class="heading-1 !text-fcrdarkgray" />
		<p class="text-fcrdarkgray text-sm md:text-base max-w-[50ch]">
			<Formatted text={tip} />
		</p>
	</div>
</div>
